import React from 'react';
import PropTypes from 'prop-types';

// Small inline SVG icons for the senior gallery. Inline (not image assets) so they
// inherit currentColor and scale with Tailwind h-*/w-* utilities.

export const CapIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 3 1 8l11 5 9-4.09V15h2V8L12 3z" />
    <path d="M5 11.18V15c0 1.66 3.13 3 7 3s7-1.34 7-3v-3.82l-7 3.18-7-3.18z" />
  </svg>
);

// The gallery's original heart, still used by the senior flow and PackageChooser. Left
// exactly as it was: the senior favorites screen is frozen on this branch.
export const HeartIcon = ({ className, filled }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth={filled ? 0 : 2}
    aria-hidden="true"
  >
    <path d="M12 21s-7.5-4.9-10-8.5C.5 9.5 2 5.5 6 5.5c2 0 3.2 1.1 4 2 .8-.9 2-2 4-2 4 0 5.5 4 4 7-2.5 3.6-10 8.5-10 8.5z" />
  </svg>
);

// The Material Icons "favorite" heart — the shape people already read as a favorite
// button everywhere else (Instagram, YouTube, Google). Used by the elementary card's
// caption row; the hand-rolled one above doesn't read as a heart at 18px.
export const FavoriteIcon = ({ className, filled }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : 'none'}
    stroke="currentColor"
    strokeWidth={filled ? 0 : 1.8}
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" />
  </svg>
);

// Pager arrow for the enlarged view. ONE path, pointed by `direction` — the right-facing
// chevron is the left one rotated, so there is no second hand-drawn path to drift out of
// step with the first.
export const ChevronIcon = ({ className, direction }) => (
  <svg
    className={`${className}${direction === 'right' ? ' rotate-180' : ''}`}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="15 5 8 12 15 19" />
  </svg>
);

export const CheckCircleIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2a10 10 0 100 20 10 10 0 000-20zm-1.2 14.2-4-4L8.2 10.8l2.6 2.6 5-5L17.2 9.8l-6.4 6.4z" />
  </svg>
);

CapIcon.defaultProps = { className: '' };
CapIcon.propTypes = { className: PropTypes.string };

HeartIcon.defaultProps = { className: '', filled: false };
HeartIcon.propTypes = { className: PropTypes.string, filled: PropTypes.bool };

FavoriteIcon.defaultProps = { className: '', filled: false };
FavoriteIcon.propTypes = { className: PropTypes.string, filled: PropTypes.bool };

ChevronIcon.defaultProps = { className: '', direction: 'left' };
ChevronIcon.propTypes = { className: PropTypes.string, direction: PropTypes.oneOf(['left', 'right']) };

CheckCircleIcon.defaultProps = { className: '' };
CheckCircleIcon.propTypes = { className: PropTypes.string };
